const NAME = "KPI_INDICATORS_PAGE";

export default NAME;
